









import { Component, Vue, Prop } from 'vue-property-decorator'
import router from '@/router'

@Component
export default class Search extends Vue {
  @Prop({ default: '搜索' }) private place: string
  private searchStr: string = ''

  protected search() {
    this.$emit('search', this.searchStr)
    // if (!this.searchStr) {
    //   this.$message.warning('请输入要搜索的内容');
    //   return
    // } else {
    //   this.$emit('search', this.searchStr)
    // }
  }

}
